import styled from 'styled-components';
import AdditionalDocuments from './AdditionalDocuments';

export default styled(AdditionalDocuments)`
  .additional-documents {
    &_24h-message {
      color: var(--grey700);
    }
  }
`;
